import AxiosBusiness from '@/services/api/business/axios_business'

export default {
  // Service endpoints
  createService: (data) => {
    return AxiosBusiness.post('service', data)
  },

  updateService: (serviceId, data) => {
    return AxiosBusiness.put(`service/${serviceId}`, data)
  },

  deleteService: (serviceId) => {
    return AxiosBusiness.delete(`service/${serviceId}`)
  },

  getService: (serviceId) => {
    return AxiosBusiness.get(`service/${serviceId}`)
  },

  getServicesByCustomer: (customerId, params = {}) => {
    return AxiosBusiness.get(`service/customer/${customerId}`, { params })
  },
}
